import React from 'react';
import PropTypes from 'prop-types';

import { FormControl as MUIFormControl } from '@mui/material';

// v5 changed FormControl's own default variant from 'standard' (v4) to 'outlined' —
// restored here so consumers that don't explicitly set one keep the old look.
export const FormControl = ({ variant = 'standard', ...props }) => <MUIFormControl variant={variant} {...props} />;

FormControl.propTypes = {
  classes: PropTypes.object,
  component: PropTypes.elementType,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  focused: PropTypes.bool,
  fullWidth: PropTypes.bool,
  margin: PropTypes.oneOf(['none', 'dense', 'normal']),
  required: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium']),
  style: PropTypes.object,
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled'])
};

export default FormControl;
